<template>
    <div :key="key" class="select-remote-filter-custom">
        <el-select
            v-model="_value"
            :remote-method="remoteMethod"
            :loading="loading"
            v-bind="$attrs"
            filterable
            remote
            v-on="$listeners">
            <el-option
                v-for="item in filterOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"/>
        </el-select>
    </div>
</template>

<script>
export default {
  name: "SelectRemoteFilterCustom",
  
  inheritAttrs: false,

  props: {
    value: {
      default: "",
      type: [String, Number, Boolean]
    },
    options: {
      type: Array,
      require: true,
      default: () => []
    }
  },

  data() {
    return {
      key: `SelectRemoteFilterCustomID-${Math.random()
        .toString(36)
        .slice(2)}`,
      filterOptions: [],
      loading: false
    };
  },

  computed: {
    _value: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },

  methods: {
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        setTimeout(() => {
          this.filterOptions = this.options.filter(item => {
            return item.label.toLowerCase().includes(query.toLowerCase());
          });
          this.loading = false;
        }, 0);
      } else {
        this.filterOptions = [];
      }
    }
  }
};
</script>

<style lang="scss">
.select-remote-filter-custom {
  display: inline-block;
}
</style>
